<template>
    <div class="bg-white relative rounded shadow-panel">
        <div class="p-4">
            <v-loader></v-loader>
        </div>
    </div>
</template>

<script>
    import LoaderVue from './../_Table/Loader.vue';
    export default {
        components: {
            'v-loader': LoaderVue
        },
        props: ['loading']
    }
</script>
